export default __webpack_public_path__ + "211bdbc54f7de8f9de8a021c2b6feae1.svg";